export enum PokerRoom {
  ClubGG = 'ClubGG',
  FishPoker = 'FishPoker',
  Xpoker = 'Xpoker',
  Suncity = 'Suncity',
  Pokerrrr2 = 'Pokerrrr2',
  Tiger = 'Tiger',

  UniversePoker = 'UniversePoker',
  ArmaniPoker = 'ArmaniPoker',
  StarsPoker = 'StarsPoker',
  Space = 'Space',
  DesertDiamond = 'DesertDiamond',
  Acc = 'Acc',
  BatrynOroo = 'BatrynOroo',
  Gutal = 'Gutal',
  RounderCasino = 'RounderCasino',
  MegamaxPoker = 'MegamaxPoker',
  OneKing = 'OneKing',
  Strike = 'Strike',
  GOT = 'GOT',
  FullHouse = 'FullHouse',
  ZoomPoker = 'ZoomPoker',
  TodazPoker = 'TodazPoker',
  OneWin = 'OneWin',
  AjnaiPoker = 'AjnaiPoker',
  FullBet = 'FullBet',
  CoolPoker = 'CoolPoker',
  EbPoker = 'EbPoker',

  Revolution = 'Revolution',
  Ppp = 'Ppp',
  BcPoker = 'BcPoker',
  AAPokerKRW = 'AAPokerKRW',
  PokerMan = 'PokerMan',
  PokerShip = 'PokerShip',
  PokerNow = 'PokerNow',
  AKGame = 'AKGame',
  QQPoker = 'QQPoker',
  PokerBros = 'PokerBros',
  GoPoker = 'GoPoker',
}
